const CONTENT_PADDING = 40;
const MIN_CONTENT_WIDTH = 480;
const MIN_CONTENT_HEIGHT = 360;

/**
 * A saved floor plan is a set of absolute-pixel positions/sizes, captured once from whatever
 * screen the editor happened to be viewed on - there's no device-independent unit involved
 * anywhere. Both the editor and the read-only order-view dashboard render every table/element at
 * that true saved size (nothing here ever shrinks it) - `.floorPlanCanvas`'s own
 * `overflow: auto` handles anything that doesn't fit on one screen with real scrolling, so a
 * layout looks and measures the same, at the same size, in the editor as it does in daily use.
 *
 * This just computes the content's bounding box (`contentWidth`/`contentHeight`), which sizes the
 * scrollable canvas: `bounds="parent"` on each table's `<Rnd>` is set to this, so a canvas sized to
 * "just barely contain what's here already" would become a wall staff can't drag a table past -
 * exactly backwards for building out a large venue (60+ tables) from a mostly-empty one. The
 * editor passes a generously large `minWidth`/`minHeight` up front (bigger than any one screen)
 * for that reason; the dashboard passes none, so its canvas is sized to exactly what's there.
 * Either way this still grows further via the `Math.max(...)` below if items get placed beyond it.
 */
export default function useFloorPlanFit(items, options = {}) {
  const { minWidth = MIN_CONTENT_WIDTH, minHeight = MIN_CONTENT_HEIGHT } = options;

  const contentWidth = Math.max(
    minWidth,
    ...items.map((item) => (item.position_x || 0) + (item.width || 0) + CONTENT_PADDING)
  );
  const contentHeight = Math.max(
    minHeight,
    ...items.map((item) => (item.position_y || 0) + (item.height || 0) + CONTENT_PADDING)
  );

  return { scale: 1, contentWidth, contentHeight };
}
